<template>
	<div class="me-avatar">
    <img v-if="isImage" :src="image" :alt="name"/>
    <span v-else>{{ initials }}</span>
  </div>
</template>

<script>
export default {
	props: {
		image: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
	},

  computed: {
		initials() {
			if (!this.name) {
				return '';
			}

			const chunks = this.name.split(' ');
			const length = Math.min(2, chunks.length);
			let initialsValue = '';

			for (let i = 0; i < length; i += 1) {
				initialsValue += chunks[i].charAt(0).toUpperCase();
			}

			return initialsValue;
		},
		isImage() {
			return this.image.length;
		}
	}
}
</script>

<style lang="stylus" scoped>
.me-avatar
  width 1.5rem
  height 1.5rem
  font-size 0.75rem
  line-height 1rem
  background-color #00519D
  color white
  display flex
  align-items center
  justify-content center
  overflow hidden
  border-radius 9999px

  @media screen and (min-width 1280px)
    width 2rem
    height 2rem

  img
    max-width 100%
</style>
